// extracted by mini-css-extract-plugin
export default {"alignCenter":"styles_alignCenter__rLk67","buttonGroup":"styles_buttonGroup__kgY8g"};